import React from 'react'
import PropTypes from 'prop-types'
import LogoWhite from '../images/de-graaff-logo-wit.svg'

export default class PageEnd extends React.Component {
  render() {
    return (
      <div className="PageEnd">
        <div className="inner">
          <div className="PageEnd-left">
            <img
              style={{ display: 'block' }}
              className="PageEnd-logo"
              src={LogoWhite}
              alt="De Graaff Financieel Advies"
            />
          </div>

          <div className="PageEnd-right">
            <p className="text-white">2018 © De Graaff Financieel Advies</p>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PageEnd.js